<template lang="html">
  <div class="main-container">
   <!-- Author: Vaishnavi
      Date: 12/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />

    <div class="margintop-32">
      <tl-header class="title" type="h3">Loan Details</tl-header>
    </div>

    <div class="loan-details-box margintop-24">
      <div class="loan-container">
        <div>
          <span>
            <label class="loan-type-text">Type of Loan: </label>
            <label class="loan-detail-text">Home loan</label>
          </span>
        </div>
        <div>
          <span>
            <label class="loan-type-text">Loan Amount: </label>
            <label class="loan-detail-text">Rs: 400000</label>
          </span>
        </div>
        <div>
          <span>
            <label class="loan-type-text">Rate of Interest: </label>
            <label class="loan-detail-text">4%</label>
          </span>
        </div>
        <div>
          <span>
            <label class="loan-type-text">Opening Balance for Financial Year 2019-2020: </label>
            <label class="loan-detail-text">Rs 20000</label>
          </span>
        </div>
        <div>
          <span>
            <label class="loan-type-text">Number of Installments: </label>
            <label class="loan-detail-text">12 (
              < Monthly)</label>
          </span>
        </div>
        <div>
          <span>
            <label class="loan-type-text">Remaining Installment Value: </label>
            <label class="loan-detail-text">Rs 10000</label>
          </span>
        </div>
        <div>
          <span>
            <label class="loan-type-text">Next Date of Installment: </label>
            <label class="loan-detail-text">24 June 2019</label>
          </span>
        </div>

      </div>
    </div>

    <div class="margintop-32">
      <div>
          <span>
            <label class="joint-Loan-text-bold ">Joint Loan Details </label>
            <label class="joint-Loan-text">(only for record Purpose)</label>
          </span>
      </div>
      <hr class="margintop-8 line">
    </div>

    <div class="margintop-24">
      <div class="singleColumnGrid">
          <txt autofocus="autofocus" label="Joint Holder's Name" type="text" v-model='formData.jointHoldersName' name="jointHoldersName"
                    v-validate="'required'" :classname="errors.has('jointHoldersName')" :errormsg="errors.first('jointHoldersName')"
            />
            <tl-select class="ht-35" 
              labelText="name"
              label="Relationship With Employee"
              :options="relationShipArray" 
              :value="formData.relationship" 
              :reduce="relationship => relationship.name"
              @change="(val)=>formData.relationship=val"
            ></tl-select>
            <tl-select class="ht-35" 
              labelText="name"
              label="Percentage Share"
              :options="percentageShareArray" 
              :value="formData.percentage" 
              :reduce="percentage => percentage.name"
              @change="(val)=>formData.percentage=val"
            ></tl-select>
      </div>
    </div>


    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Back" type="secondary" @click="routeToSubStep" />
          <btn text="Save" type="primary" @click="save" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "loanDetails",
  computed: {
    ...mapState({}),
    ...mapGetters({
      orgid: "onboard/organization/orgid"
    })
  },
  data() {
    return {
      breadcrumbList:[
              {
                name: "Organisation",
                url: `/dashboard/${this.$route.params.entity_index}/organisation`
              },
              {
                name: "Utilities",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
              },
              {
                name: "Loan Details",
                url: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/loan_details`
              }
        ],
      formData: {
        jointHoldersName:"",
        relationShipArray: [{id:1,name:'Father'},{id:2,name:'Mother'},{id:3,name:'Son'},{id:4,name:'Daughter'}],
        percentageShareArray: [{id:1,name:'10%'},{id:2,name:'20%'},{id:3,name:'30%'},{id:4,name:'40%'}],
        percentage:"",
        relationship:""
      }
    };
  },
  mounted() {},

  methods: {
    ...mapActions({}),

    routeToSubStep() {
      this.$router.push({ path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities` });
    },
    routeToMainStep() {
      this.$router.push({ path: `/dashboard/${this.$route.params.entity_index}/organisation` });
    },

    save() {}
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";  //margins

.header.header3 {
  padding-bottom: 0px;
}

.loan-details-box {
  width: 45.1%;
  height: 190px;
  background-color: #f1f1f1;
  .loan-container {
    padding: 25px 20px;
  }
  .loan-type-text {
    font-family: Montserrat;
    font-size: 12px;
    line-height: 1.67;
    color: #404040;
  }
  .loan-detail-text {
    font-family: Montserrat;
    font-size: 12px;
    line-height: 1.67;
    font-weight: 600;
    color: #404040;
  }
}

.joint-Loan-text {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: normal;
  color: #646464;
}

.joint-Loan-text-bold {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: normal;
  color: #646464;
  font-weight: 600;
}

.line {
  height: 2px;
  border: solid 1px #c8c8c8;
}

.tl-select-dropdown {
     margin-bottom: 0px; 
}
</style>